export const TYPES = {
    TEAM: 0,
    CALENDAR: 1,
    FIXED: 2,
    ATHLETE_CALENDAR: 4,
    COACH_ATHLETE_CALENDAR: 5,
    INVITED_ATHLETE_CALENDAR: 6
};

export const convertToString = type => {
    switch (type) {
        case TYPES.TEAM:
            return 'team';
        case TYPES.CALENDAR:
            return 'calendar';
        case TYPES.FIXED:
            return 'program';
        case TYPES.COACH_ATHLETE_CALENDAR:
            return 'athlete';
        case TYPES.INVITED_ATHLETE_CALENDAR:
            return 'invited-athlete';
        default:
            return 'error';
    }
};

export const isCoachAthleteCalendar = type =>
    TYPES.COACH_ATHLETE_CALENDAR === parseInt(type);

export const isInvitedAthleteCalendar = type =>
    TYPES.INVITED_ATHLETE_CALENDAR === parseInt(type);

export const isCalendar = type => TYPES.CALENDAR === parseInt(type);

export const isProgram = type => TYPES.FIXED === parseInt(type);

export const isTeamCalendar = type => TYPES.TEAM === parseInt(type);

export const getAthleteValue = (type, athleteValue, programValue) => {
    return isCoachAthleteCalendar(type) || isInvitedAthleteCalendar(type)
        ? athleteValue
        : programValue;
};



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/programTypes.js